import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import { NextSeo } from "next-seo";

import Header from "../../Header";
import Footer from "../../Footer";
import SideMenu from "../../SideMenu";
import { NavigationBar } from "../../../src/components/atoms";
import { useRouter } from "next/router";
import { Values } from "../../../src/config";
import slugify from "slugify";
import { uniqBy } from "lodash";

const GuideYearCountry = (props) => {
  const { t } = useTranslation();

  const {
    listDataCountry,
    listDataState,
    listDataCity,
    listData,
    yearSelected,
    continentSelected,
    countrySelected,
  } = props;
  const router = useRouter();

  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);
  const [isMobileVersion, setIsMobileVersion] = useState(false);
  const countries = listDataCountry;
  const states = listDataState;
  const cities = listDataCity;
  const types = listData;
  const countryData = countries?.find(
    (i) => slugify(i.countryName?.toLowerCase()) === countrySelected
  );
  const metaTitle = `${countryData?.countryName}`;
  const metaDescription = `Discover ${
    process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
      ? "clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
      ? "rooftops"
      : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
      ? "cocktail bars"
      : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
      ? "spas"
      : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
      ? "beach clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
      ? "festivals"
      : "clubs"
  } in ${countryData?.countryName} with our guides.`;

  useEffect(() => {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);

  return (
    <div>
      <NextSeo
        noindex={false}
        nofollow={false}
        title={`${metaTitle} Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        description={metaDescription}
        canonical={`https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides/${yearSelected}/${continentSelected}/${countrySelected}`}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides/${yearSelected}/${continentSelected}/${countrySelected}`,
          title: `${metaTitle} Guides - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          description: metaDescription,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className="bg-black">
        <div
          className={`mx-auto relative ${
            isMobileVersion ? "px-[8px]" : "wrapper pt-[30px]"
          } pb-[130px]`}>
          <div className="max-w-1160px min-h-screen flex-1 mx-auto">
            <NavigationBar
              title={metaTitle}
              customStyle={{ marginTop: 0 }}
              isMobileVersion={isMobileVersion}
              onBackPressed={() =>
                router.push(`/guides/${yearSelected}/${continentSelected}`)
              }
            />
            <div className="flex flex-row items-center justify-center mb-[30px]">
              <div className="flex items-center justify-center bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]">
                Country
              </div>
            </div>
            <div className="flex flex-row flex-wrap items-center px-[20px]">
              {uniqBy(types, "filterId")
                ?.sort((a, b) => a?.filterOrder - b?.filterOrder)
                ?.map((item, index) => (
                  <Link
                    href={`/guides/${yearSelected}/${continentSelected}/${countrySelected}/${
                      item?.filterName === "All"
                        ? process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
                          ? "clubs"
                          : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
                          ? "rooftops"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
                          ? "cocktail-bars"
                          : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
                          ? "spas"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
                          ? "beach-clubs"
                          : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
                          ? "festivals"
                          : "clubs"
                        : slugify(item?.filterName?.toLowerCase()) +
                          `-${
                            process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
                              ? "clubs"
                              : process.env.NEXT_PUBLIC_APP_NAME ==
                                "RooftopClub"
                              ? "rooftops"
                              : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
                              ? "cocktail-bars"
                              : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
                              ? "spas"
                              : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
                              ? "beach-clubs"
                              : process.env.NEXT_PUBLIC_APP_NAME == "Festicket"
                              ? "festivals"
                              : "clubs"
                          }`
                    }`}>
                    <a
                      className={`flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white uppercase font-regular text-base text-center ${
                        isMobileVersion
                          ? "mb-[12px] mr-[12px]"
                          : "mb-[30px] mr-[30px]"
                      }`}
                      key={index}>
                      <div>{item?.filterName}</div>
                    </a>
                  </Link>
                ))}
            </div>
            {states.length > 0 && (
              <div className="flex flex-row items-center justify-center mb-[30px]">
                <div className="flex items-center justify-center bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]">
                  State
                </div>
              </div>
            )}
            {states.length > 0 && (
              <div className="flex flex-row flex-wrap items-center px-[20px]">
                {states
                  ?.sort((a, b) => {
                    if (a.stateName < b.stateName) {
                      return -1;
                    }
                    if (a.stateName > b.stateName) {
                      return 1;
                    }
                    return 0;
                  })
                  ?.map((item, index) => (
                    <Link
                      href={`/guides/${yearSelected}/${continentSelected}/${countrySelected}/${slugify(
                        item?.stateName?.toLowerCase()
                      )}-state`}>
                      <a
                        className={`flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white uppercase font-regular text-base text-center ${
                          isMobileVersion
                            ? "mb-[12px] mr-[12px]"
                            : "mb-[30px] mr-[30px]"
                        }`}
                        key={index}>
                        <div>{item?.stateName}</div>
                      </a>
                    </Link>
                  ))}
              </div>
            )}
            <div className="flex flex-row items-center justify-center mb-[30px]">
              <div className="flex items-center justify-center bg-gradient-to-bl from-gradient3 via-gradient2 to-gradient1 rounded-full text-base text-white font-bold uppercase text-center w-full max-w-[240px] h-[40px]">
                City
              </div>
            </div>
            <div className="flex flex-row flex-wrap items-center px-[20px]">
              {cities
                ?.sort((a, b) => {
                  if (a.cityName < b.cityName) {
                    return -1;
                  }
                  if (a.cityName > b.cityName) {
                    return 1;
                  }
                  return 0;
                })
                ?.map((item, index) => (
                  <Link
                    href={`/guides/${yearSelected}/${continentSelected}/${countrySelected}/${slugify(
                      item?.cityName?.toLowerCase()
                    )}`}>
                    <a
                      className={`flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white uppercase font-regular text-base text-center ${
                        isMobileVersion
                          ? "mb-[12px] mr-[12px]"
                          : "mb-[30px] mr-[30px]"
                      }`}
                      key={index}>
                      <div>{item?.cityName}</div>
                    </a>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default GuideYearCountry;
